import TextList from "components/Admin/Configurations/RatersType/List/TextList"
import React from "react"

const TextListPage = () => {
    return (
        <React.Fragment>
            <TextList />
        </React.Fragment>
    )
}
export default TextListPage
